// Detection helpers + templates for the recursive CMS editor.
export const IMAGE_KEYS = new Set([
  'photo', 'image', 'background_image', 'before_image', 'after_image',
  'og_image', 'image_url', 'logo_url',
]);

export const BOOL_KEYS = new Set(['featured', 'enabled', 'use_tls', 'auto_reply_enabled']);

export const TEXTAREA_KEYS = new Set([
  'description', 'subtitle', 'message', 'quote', 'answer', 'auto_reply_body',
]);

export function isBilingual(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const keys = Object.keys(value);
  if (keys.length === 0) return false;
  return keys.every((k) => k === 'es' || k === 'en');
}

export function templateFor(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return '';
  if (typeof value === 'number') return 0;
  if (typeof value === 'boolean') return false;
  if (Array.isArray(value)) return [];
  if (isBilingual(value)) return { es: '', en: '' };
  if (typeof value === 'object') {
    const out = {};
    for (const k of Object.keys(value)) out[k] = templateFor(value[k]);
    return out;
  }
  return '';
}
